import { Restrictions } from 'scripts/api';
import { actionCreators } from 'react/api/actions/configuration';

/* Model */
class PanelBuilderModel extends App.Models.BaseModel {
  modelUrl = "Panel";
}

App.Models.PanelBuilder = PanelBuilderModel;

/* Collection */
class PanelBuilderCollection extends App.Collections.BaseCollection {
  url = "Panel";
  model = App.Models.PanelBuilder;
}

App.Collections.PanelBuilders = PanelBuilderCollection;

/* Router */
class PanelBuilderRouter extends App.Routers.BaseRouter {
  constructor() {
    const entityName = "PanelBuilder";
    const model = App.Models.PanelBuilder;
    const collectionClass = App.Collections.PanelBuilders;

    super(entityName, model, collectionClass);

    this.tabName = "PanelBuilder";
  }

  getPanels = (fieldKeys, criteria, callbackSuccess, callbackError) => {
    const request = new Restrictions({
      entity: this.collection.url,
      fieldKeys,
      criteria,
      success: (data) => {
        $("#loading_img").hide();
        callbackSuccess(data);
      },
      error: (response) => callbackError || this.createAndUpdateErrorHandler(response, false)
    })
    
    request.send();

    $("#loading_img").show();
  };

  edit = panel => {
    var callbackSuccess = function(data) {
      if (data && data.length) {
        var form = App.Objects.PanelBuilder.renderForm(null, data[0]);
        form.setCrudStage("edit");

        App.Forms.PanelBuilder.panelBuilderList.removeAliasNewPanel();
      }
    }.bind(this);

    var criteria = {
      criteriaChain: [
        {
          and: [{ attr: "id", eq: panel.id }]
        }
      ],
      sort: [
        { attr: "panelRules.rulePriority", type: "ASC" },
        { attr: "panelRules.panelRuleConditions.id", type: "ASC" },
        { attr: "panelOrderFilters.orderPriority", type: "ASC" }
      ]
    };

    const fieldKeys = ["*", "rootEntity.*", "panelOrderFilters.*", "panelOrderFilters.entityField.*", "panelFilters.*","panelFilters.entityField.*","panelFilters.entityField.lookupEntity.key","restrictToOrganizations.*", "panelCardFields.*", "panelCardFields.field.*",  "panelCardFields.field.lookupEntity.key","panelRules.*", "panelRules.panelRuleConditions.*", "panelRules.panelRuleConditions.entityField.*", "panelRules.panelRuleConditions.entityField.lookupEntity.key"];

    this.getPanels(fieldKeys, criteria, callbackSuccess);
  };

  clone = panel => {
    console.error("Ops...Sorry,but this is not implemented yet.");
  };

  form_new = () => {
    var form = App.Objects.PanelBuilder.renderForm(null, null);
    form.setCrudStage("new");

    App.Forms.PanelBuilder.panelBuilderList.setAliasNewPanel();
  };

  delete = item => {
    var ajax = new Monet.Ajax();
    ajax.url = this.collection.url + "/" + item.id;
    ajax.method = "DELETE";
    ajax.success = App.Objects.PanelBuilder.list.bind(this);

    ajax.error = function(response) {
      this.createAndUpdateErrorHandler(response, false);
    }.bind(this);

    ajax.send();
    $("#loading_img").show();
  };

  show = panel => {
    window.location = "#/Panel/" + panel.id;
  };

  list = () => {

    this.updateTabTitle({
      userInterfaceAction: {
        userInterface: {
          description : "Greenmile.panelBuilder.tabTitle"
        }
      }
    });

    this.getPanels(["id","name", "rootEntity.key"],
      "{}",
      data => {
        if (data) {
          this.render(data);
        }
      }
    );
  };

  getTab = () => {
    return document.querySelector("#PanelBuilder");
  };

  render = items => {
    var formContainer = document.querySelector(".formContainer");
    if (formContainer) {
      formContainer.innerHTML = "";
    } else {
      formContainer = document.createElement("div");
      formContainer.className = "formContainer";

      const helpButton = new Monet.UI.Help(
        "PanelBuilder",
        Monet.I18n.getResourcesByKey("Greenmile.panelBuilder.tabTitle")
      ).renderLink();

      const topButtonsContainer = document.createElement('div');
      topButtonsContainer.id = 'topButtonsContainer';
      topButtonsContainer.appendChild(helpButton);

      const panelBuilderHeader = document.createElement('div');
      panelBuilderHeader.id = 'panelBuilderHeader';
      panelBuilderHeader.setAttribute('class', 'gridHeaderContainer');

      panelBuilderHeader.appendChild(topButtonsContainer);

      this.getTab().appendChild(panelBuilderHeader);
    }

    const panelBuilderList = this.renderList(formContainer, items);
    this.renderForm(formContainer);
    this.getTab().appendChild(formContainer);
    if (App.Forms.PanelBuilder && App.Forms.PanelBuilder.form) {
      App.Forms.PanelBuilder.form.postRender();
    }

    App.Forms.PanelBuilder.panelBuilderList = panelBuilderList;

    this.updatePanelsListMenu(items);
  };

  updatePanelsListMenu = (items) => {
    const currentlyConfigurationState = GreenmileReduxStore.getState().configuration;
    const haveTheSameLength = (receivedPanels, currentPanels) => receivedPanels.length === currentPanels.length;
    const haveChangedNameOfPanels = (receivedPanels, currentPanels) => {
      return currentPanels.filter( (panel, index) => panel.name !== receivedPanels[index].name );
    };

    const updateList = (receivedPanels, currentPanels) => {
      const newStatePanels = receivedPanels.map( panel => {
        const newPanel = {
          id: panel.id,
          name: panel.name
        };

        const isNotANewPanel = currentPanels.filter( currentPanel => currentPanel.id === panel.id);

        if(isNotANewPanel.length) {
          newPanel.openAtLogin = isNotANewPanel[0].openAtLogin;
        } else {
          newPanel.openAtLogin = false;
        }

        return newPanel;
      });

      currentlyConfigurationState.panels = newStatePanels;

      GreenmileReduxStore.dispatch(actionCreators.updateMenuPanelBuilder({
        configuration: currentlyConfigurationState
      }));
    };

    if(currentlyConfigurationState?.panels) {
      const panels = currentlyConfigurationState.panels;

      if(!haveTheSameLength(items, panels) || haveChangedNameOfPanels(items, panels).length) {
        updateList(items, panels);
      }
    }
  };

  renderList = (parent, items) => {
    var list = new Greenmile.PanelBuilder.List();
    parent.appendChild(list.render());
    list.setValue(items);

    return list;
  };

  onValidate = () => {
    var form = App.Forms.PanelBuilder.form;
    form.buildCard.validate(this);
    form.ruleManager.validate(this);
    form.filterManager.validate(this);
  };

  afterAppendErrorMessage = () => {
    App.Forms.PanelBuilder.form.postRender();
  };

  renderForm = (parent, data) => {
    if (!parent) {
      parent = document.querySelector("#PanelBuilder .formContainer ");
    }
    var oldForm = parent.querySelector(".MonetUIForm.PanelBuilder");
    if (oldForm) {
      parent.removeChild(oldForm);
    }

    var form = new Greenmile.PanelBuilder.Form(null, "PanelBuilder");
    form.render();

    if (data) {
      form.setValue(data);
    }

    parent.appendChild(form.rootEl);

    this.checkSideCardToShowFirst(form);

    form.postRender();

    App.Forms.PanelBuilder = App.Forms.PanelBuilder || {};
    App.Forms.PanelBuilder.form = form;

    this.setFormModel();

    return form;
  };

  checkSideCardToShowFirst = (form) => {
    if(form.value && form.value.cardSideToShow === 'BACK') {
      new Greenmile.PanelBuilder.BuildCard()
        .flipCards();
    }
  };

}

App.Routers.PanelBuilder = PanelBuilderRouter;
